
















import { Component, Prop, Model } from 'vue-property-decorator';
import Vue from 'vue';


@Component
export default class UiRadioGroup extends Vue {
  @Model('change')
  modelValue: any

  @Prop({ default: false })
  disabled: boolean
  
  // inline
  // inline-values
  // horizontal-line
  @Prop({ default: '' })
  styleType: string

  @Prop({ default: '' })
  label: string

  @Prop()
  labelHelp: string;

  @Prop()
  color: string

  get spaceBetweenLabelAndRadio() {
    if(!this.$slots.label && !this.label || this.styleType==='inline' || this.styleType==='horizontal-line') return
    return 'mt-4'
  }
}
